import React   from 'react';
import '../assets/css/second_payment_slip_new.css';
import PaymentSlip from '../components/SecondPaymentSlipNew/PaymentSlip';


const SecondPaymentSlipNew = () => {

  return (
    <div>
      <PaymentSlip />
    </div>
  );
};

export default SecondPaymentSlipNew;


/** WEBPACK FOOTER **
 ** ./src/containers/SecondPaymentSlipNew.js
 **/